const config = {
  authorizationServiceBaseUrl: '',
  onboardingServiceBaseURL: '',
  customerLifeCycleServiceBaseURL: '',
  payoutServiceBaseURL: '',
  chargerManagementServiceBaseUrl: '',
  documentManagementServiceBaseUrl: '',
  contactFormServiceBaseUrl: '',
  appInsightsKey: '',
  apiUrl: '',
  adyenClientKey: '',
  adyenEnv: '',
  marketingWebsiteUrl: '',
  universLoginPage: '',
  authStorageKey: '',
  authCookieName: '',
  ssoCookieName: '',
  authParentDomain: '',
  blobAssetUrl: '',
  nodeEnv: '',
  devMode: false,
  sentryEnv: 'local_development',
  b2bPortalWebsiteUrl: '',
}

let isConfigLoaded = false
let configLoadPromise = null

export const getConfig = async () => {
  if (isConfigLoaded) {
    return config
  }

  if (!configLoadPromise) {
    configLoadPromise = (async () => {
      try {
        const response = await fetch('/config.json')
        if (!response.ok) {
          console.error('Failed to load config.json, using default values.')
        } else {
          const envConfig = await response.json()
          config.authorizationServiceBaseUrl =
            envConfig.REACT_APP_AUTHORIZATION_BASE_URL
          config.onboardingServiceBaseURL =
            envConfig.REACT_APP_ONBOARDING_BASE_URL
          config.customerLifeCycleServiceBaseURL =
            envConfig.REACT_APP_CUSTOMER_LIFE_CYCLE_BASE_URL
          config.payoutServiceBaseURL =
            envConfig.REACT_APP_PAYOUT_SERVICE_BASE_URL
          config.chargerManagementServiceBaseUrl =
            envConfig.REACT_APP_CHARGER_MANAGEMENT_BASE_URL
          config.documentManagementServiceBaseUrl =
            envConfig.REACT_APP_DOCUMENT_MANAGER_BASE_URL
          config.contactFormServiceBaseUrl =
            envConfig.REACT_APP_CONTACT_FORM_BASE_URL
          config.assetManagementServiceBaseUrl =
            envConfig.REACT_APP_ASSET_MANAGEMENT_BASE_URL
          config.appInsightsKey = envConfig.REACT_APP_APPLICATION_INSIGHTS_KEY
          config.adyenClientKey = envConfig.REACT_APP_ADYEN_CLIENT_KEY
          config.adyenEnv = envConfig.REACT_APP_ADYEN_ENV
          config.marketingWebsiteUrl = envConfig.REACT_APP_MARKETING_WEBSITE_URL
          config.universLoginPage = envConfig.REACT_APP_UNIVERS_LOGIN_PAGE
          config.authStorageKey = envConfig.REACT_APP_AUTH_STORAGE_KEY
          config.authCookieName = envConfig.REACT_APP_AUTH_COOKIE_NAME
          config.ssoCookieName = envConfig.REACT_APP_SSO_COOKIE_NAME
          config.authParentDomain = envConfig.REACT_APP_AUTH_PARENT_DOMAIN
          config.blobAssetUrl = envConfig.REACT_APP_BLOB_ASSET_URL
          config.nodeEnv = envConfig.NODE_ENV
          config.devMode = envConfig.REACT_APP_ENABLE_DEVELOPER_MODE
          config.sentryEnv = envConfig.REACT_APP_SENTRY_ENV
          config.b2bPortalWebsiteUrl =
            envConfig.REACT_APP_B2B_PORTAL_WEBSITE_URL
        }
      } catch (error) {
        console.error('Error loading Configurations: ' + error)
      } finally {
        isConfigLoaded = true
      }
      return config
    })()
  }

  return configLoadPromise
}

export default config
